import React from 'react';
import {
  BadgeCheck,
  CalendarDays,
  CheckCircle2,
  LocateFixed,
  TrendingUp,
  Users,
} from 'lucide-react';

function safeItems(items) {
  return Array.isArray(items) ? items.filter((item) => String(item || '').trim()) : [];
}

export function SpotlightCommunityImpactBox({ city, items }) {
  const rows = safeItems(items);

  return (
    <>
      <div className="mb-3 inline-flex items-center gap-2 text-lg font-semibold" style={{ color: 'var(--primary)' }}>
        <Users size={18} /> COMMUNITY IMPACT
      </div>
      <p className="mb-3 text-sm" style={{ color: 'var(--page-body-color)' }}>Proudly supporting and showing up for {city || 'Roswell'}.</p>
      <ul className="space-y-2 text-sm" style={{ color: 'var(--page-body-color)' }}>
        {rows.map((item) => (
          <li key={item} className="flex items-start gap-2">
            <CheckCircle2 size={15} className="mt-0.5" style={{ color: 'var(--primary)' }} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </>
  );
}

export function SpotlightDifferentiatorsBox({ items }) {
  const rows = safeItems(items);

  return (
    <>
      <div className="mb-3 inline-flex items-center gap-2 text-lg font-semibold" style={{ color: 'var(--primary)' }}>
        <BadgeCheck size={18} /> WHY THIS BUSINESS IS DIFFERENT
      </div>
      <ul className="space-y-2 text-sm" style={{ color: 'var(--page-body-color)' }}>
        {rows.map((item) => (
          <li key={item} className="flex items-start gap-2">
            <CheckCircle2 size={15} className="mt-0.5" style={{ color: 'var(--primary)' }} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </>
  );
}

export function SpotlightThisWeekBox({ weekItems }) {
  const rows = Array.isArray(weekItems) ? weekItems : [];

  return (
    <>
      <div className="mb-3 inline-flex items-center gap-2 text-lg font-semibold" style={{ color: 'var(--primary)' }}>
        <CalendarDays size={18} /> THIS WEEK
      </div>
      <p className="mb-3 text-sm" style={{ color: 'var(--page-body-color)' }}>What's happening soon.</p>
      <div className="space-y-2">
        {rows.map((item) => (
          <div
            key={`${item.title}-${item.date || ''}`}
            className="rounded-lg border px-3 py-2"
            style={{
              borderColor: 'var(--ui-input-border)',
              backgroundColor: 'var(--card)',
            }}
          >
            <p className="text-sm font-semibold" style={{ color: 'var(--page-heading-color)' }}>{item.title}</p>
            <p className="text-xs" style={{ color: 'var(--page-body-color)' }}>{item.when || item.date || 'Details coming soon'}</p>
          </div>
        ))}
      </div>
    </>
  );
}

export function SpotlightLocalRelevanceBox({ items }) {
  const rows = safeItems(items);

  return (
    <>
      <div className="mb-3 inline-flex items-center gap-2 text-lg font-semibold" style={{ color: 'var(--primary)' }}>
        <LocateFixed size={18} /> LOCAL RELEVANCE
      </div>
      <ul className="space-y-2 text-sm" style={{ color: 'var(--page-body-color)' }}>
        {rows.map((item) => (
          <li key={item} className="flex items-start gap-2">
            <CheckCircle2 size={15} className="mt-0.5" style={{ color: 'var(--primary)' }} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </>
  );
}

export function SpotlightFreshnessActivityBox({ items }) {
  const rows = safeItems(items);

  return (
    <>
      <div className="mb-3 inline-flex items-center gap-2 text-lg font-semibold" style={{ color: 'var(--primary)' }}>
        <TrendingUp size={18} /> FRESHNESS & ACTIVITY
      </div>
      <ul className="space-y-2 text-sm" style={{ color: 'var(--page-body-color)' }}>
        {rows.map((item) => (
          <li key={item} className="flex items-start gap-2">
            <CheckCircle2 size={15} className="mt-0.5" style={{ color: 'var(--primary)' }} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </>
  );
}
